import { FC, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import Placeholder from '../../shared/Placeholder';
import Loader from '../../shared/Loader';
import Header from '../../shared/Header';
import { Stack } from '../../shared/layouts';
import MessagebarContext from '../../../context/MessagebarContext';
import { useTranslation } from 'react-i18next';
import useIconLibrary from '../../../hooks/useIconLibrary';
import { fetchRequestsList } from './requestTypes';
import RequestList from './RequestList';

const RequestsPage: FC = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const status = urlSearchParams.get('status');
  const { setSuccesMessage, setAlertMessage } = useContext(MessagebarContext);
  const { isLoading, isError, data: requestItems = [] } = useQuery(
    'RequestsList',
    () => fetchRequestsList()
  );
  const placeholder = isError
    ? t('Er konden geen verzoeken opgehaald worden')
    : t('Er zijn nog geen verzoeken binnengekomen');

  useEffect(() => {
    if (status === 'success') {
      setSuccesMessage(t('Verzoek wordt verwerkt'));
    } else if (status === 'failure') {
      setAlertMessage(t('Verzoek mislukt'));
    }
  }, []);

  const { RequestIcon } = useIconLibrary();

  return (
    <>
      {isLoading && <Loader />}
      <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
        <Header
          title={t('Verzoeken')}
          icon={<RequestIcon height="2rem" width="2rem" />}
          variant="page"
        />
        {requestItems.length === 0 || isError ? (
          <Placeholder>{placeholder}</Placeholder>
        ) : (
          <RequestList data={requestItems} />
        )}
      </Stack>
    </>
  );
};

export default RequestsPage;
